var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"value-cell",class:{ 'not-available': !_vm.hasValue }},[(_vm.hasValue)?[(_vm.$slots.default)?_vm._t("default"):_c('span',[_vm._v(_vm._s(_vm.value))])]:[_vm._v(" "+_vm._s(_vm.$t('general.table.not-available'))+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }